import { handleAuthorization, handleOkResponseJson, handleBadRequest400 } from "./handlers"
import { obterToken } from "./loginService"
import { abrirBlobPdf, fecharJanelaPdf } from "./pdfHelper"
import * as axios from 'axios';

export const obterEntradasNFAsync = async () => {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
    };
    return fetch(`${process.env.VUE_APP_API_URL}/EntradaNF/obterLista`, requestOptions)
        .then(handleAuthorization)
        .then(handleOkResponseJson)
        .then(result => {
            return result.data;
        });
}

export const enviarEntradaNFAsync = async (dataEmissao, numero, idFornecedor, idCondicaoPagamento, idUnidadeAdm, informacoesAdicionais, idPedido, tipoPedido, desconto, acrescimo, subtotal, total, itens) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
        body: JSON.stringify({ dataEmissao, numero, idFornecedor, idCondicaoPagamento, idUnidadeAdm, informacoesAdicionais, idPedido, tipoPedido, desconto, acrescimo, subtotal, total, itens })
    };return fetch(`${process.env.VUE_APP_API_URL}/EntradaNF`, requestOptions)
        .then(handleAuthorization)
        .then(handleOkResponseJson)
        .then(result => {
            return result.data;
        });
}

export const editarEntradaNFAsync = async (id, dataEmissao, numero, idFornecedor, idCondicaoPagamento, idUnidadeAdm, informacoesAdicionais, desconto, acrescimo, subtotal, total, itens) => {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
        body: JSON.stringify({ id, dataEmissao, numero, idFornecedor, idCondicaoPagamento, idUnidadeAdm, informacoesAdicionais, desconto, acrescimo, subtotal, total, itens })
    };
    return fetch(`${process.env.VUE_APP_API_URL}/EntradaNF/atualizar`, requestOptions)
        .then(handleAuthorization)
        .then(handleOkResponseJson)
        .then(result => {
            return result.data;
        });
}

export function getPdf(id, janelaPdf = null) {
    try {
        return axios({
            url: `${process.env.VUE_APP_ROOT_API}/EntradaNF/downloadPdf/` + id,
            method: 'GET',
            responseType: 'blob',
            headers: { 'Content-Type': 'application/json', 'Authorization': 'bearer ' + obterToken() },
        }).catch(() => {
            fecharJanelaPdf(janelaPdf);
            return { status: false };
        })
            .then((response) => {
                if (response.status === false) {
                    fecharJanelaPdf(janelaPdf);
                    return response;
                }
                abrirBlobPdf(response.data, janelaPdf);
            });
    } catch (e) {
        fecharJanelaPdf(janelaPdf);
        throw e;
    }
}
